import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import "../styles/pages/stations_page.css";
import Header from "../components/Header.jsx";
import Button from "../components/Button.jsx";
import Loader from "../components/Loader";
import NoImageItem from "../components/NoImageItem.jsx";
import { fetchStations, deleteStation } from "../services/stationsService";
import StationForm from "../components/StationForm.jsx";
import Modal from "../components/Modal.jsx";

const StationsPage = () => {
  const [stationsItems, setStationsItems] = useState([]);
  const [showStationForm, setShowStationForm] = useState(false);
  const [stationFormMode, setStationFormMode] = useState("create");
  const [currentStationData, setCurrentStationData] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const getStations = async () => {
    setIsLoading(true);
    try {
      const data = await fetchStations().catch((err) => {
        if (err?.response?.status === 404) return [];
        throw err;
      });

      setStationsItems(
        Array.isArray(data)
          ? data.map((station) => ({
            id: station.id,
            title: station.gs_serial,
            hasEdit: true,
            fullData: station,
          }))
          : []
      );
    } catch (error) {
      if (error.response?.status === 403) {
        toast.error("Время сессии истекло, пожалуйста войдите заново", {
          position: "bottom-left",
          autoClose: 3000
        });
      } else {
        toast.error("Не удалось загрузить станции", {
          position: "bottom-left",
          autoClose: 3000
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getStations();
  }, []);

  const handleEdit = (station) => {
    setCurrentStationData(station.fullData);
    setStationFormMode("edit");
    setShowStationForm(true);
  };

  const handleDelete = (station) => {
    setDeleteTarget(station);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    if (!deleteTarget) return;

    try {
      await deleteStation(deleteTarget.fullData.id);
      await getStations();
      toast.success("Станция успешно удалена", {
        position: "bottom-left",
        autoClose: 3000
      });
    } catch (error) {
      if (error.response?.status === 403) {
        toast.error("Время сессии истекло, пожалуйста войдите заново", {
          position: "bottom-left",
          autoClose: 3000
        });
      } else {
        toast.error("Не удалось удалить станцию", {
          position: "bottom-left",
          autoClose: 3000
        });
      }
    } finally {
      setShowDeleteModal(false);
      setDeleteTarget(null);
    }
  };

  const handleAdd = () => {
    setCurrentStationData(null);
    setStationFormMode("create");
    setShowStationForm(true);
  };

  return (
    <div className="stations-page">
      <Header />
      <ToastContainer />

      {isLoading ? (
        <div className="loader-wrapper">
          <Loader />
          <p className="loading-text">Загрузка станций...</p>
        </div>
      ) : (
        <div className="stations-page_content">
          <div className="stations_section">
            <h3 className="section-title">Список АЗС</h3>
            <div className="items-container">
              {stationsItems.length > 0 ? (
                stationsItems.map((item, index) => (
                  <div key={item.id} className="numbered-item">
                    <span className="item-number">{index + 1}</span>
                    <NoImageItem
                      title={item.title}
                      onEdit={() => handleEdit(item)}
                      onDelete={() => handleDelete(item)}
                    />
                  </div>
                ))
              ) : (
                <p className="empty-list-label">Список пуст</p>
              )}
              <Button
                text="+ Добавить"
                onClick={handleAdd}
                className="add-button"
              />
            </div>
          </div>
        </div>
      )}

      {showStationForm && (
        <StationForm
          onClose={() => setShowStationForm(false)}
          initialData={currentStationData}
          mode={stationFormMode}
          onSuccess={getStations}
        />
      )}

      {showDeleteModal && (
        <Modal
          isOpen={showDeleteModal}
          message="Вы действительно хотите удалить станцию?"
          itemTitle={deleteTarget?.title}
          onCancel={() => setShowDeleteModal(false)}
          onConfirm={handleConfirmDelete}
        />
      )}
    </div>
  );
};

export default StationsPage;
